<template>
    <div class="ui segment center aligned">
        <div v-if="eventbus.print_label.is_processing">
            <div class="ui active inverted dimmer"
                style="height: 100px;">
                <div class="ui text loader">運單標籤 載入中</div>
            </div>
        </div>
        <div v-else>
            <p v-if="eventbus.print_label.error"
                style="color:red;">
                {{ eventbus.print_label.error }}
            </p>
            <div v-else
                style="position: relative;">
                <img
                    v-if="eventbus.print_label.src"
                    class="label_img"
                    :dataset-number="core_waybill.number"
                    :src="eventbus.print_label.src">
                <div v-else
                    class="ui button no orange border"
                    @click="$bus.$emit(eventbus.print_label.refetch_name)">
                    <i class="frown icon"></i>
                    標籤載入錯誤，點選我重新載入
                </div>

                <div v-if="eventbus.print_label.src"
                    class="ui tiny icon button"
                    style="position: absolute;right: 0;bottom: 0;margin: 0;"
                    @click="$bus.$emit(eventbus.print_label.refetch_name)">
                    <i class="refresh icon"></i>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    props: {
        core_waybill: {
            default: {},
            type: Object
        },
        eventbus: {
            default: {
                change_current_template: {
                    name: "",
                },
                file_uploader: {
                    name: "",
                },
                update_core_waybill: {
                    name: "",
                },
                print_label: {
                    name: "",
                },
            },
            type: Object,
        },
        is_auto_print: {
            default: false,
            type: Boolean
        },
        is_enable_auto_print_label: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
        }
    },
    created() {
    },
    mounted() {
        this.init()
    },
    computed: {
    },
    watch: {
        'eventbus.print_label.name': {
            deep: true,
            handler(value) {
                this.init()
            }
        },
    },
    methods: {
        async init() {
            this.is_processing = true
            await new Promise(resolve => {
                // if (this.is_auto_print == true && this.is_enable_auto_print_label) {
                //     this.$bus.$emit(this.eventbus.print_label.name)
                // }
                resolve()
            })
            await new Promise(resolve => {
                this.is_processing = false
                resolve()
            })
        },
    },
    components: {
    },
}
</script>

<style lang="scss" scoped>
    .ui.segments.core_waybill .label_img {
        width:100%;
        max-width: 100mm !important;
        max-height: 100mm !important;
    }
</style>
